export const routes = [
  {
    title: "menu",
    link: "#menu",
  },
  {
    title: "gift cards",
    link: "#gift-cards",
  },
  {
    title: "reviews",
    link: "#reviews",
  },
  {
    title: "about us",
    link: "#about-us",
  },
  {
    title: "loyalty",
    link: "https://www.toasttab.com/nielsens-frozen-custard-durango-casino-6915-south-durango-drive/rewardsSignup",
  },
];
